export const currencyFormatter = Intl.NumberFormat('en-us', {
    style: 'currency',
    currency: 'USD'
});
